import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { HarborImageList } from './HarborImageList';

export const HarborImageListExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'HarborImageList',
    component: HarborImageList,
    validation: () => Promise.resolve(),
  }),
);
